import {
  FormField,
  FormItem,
  FormControl,
  FormMessage,
} from "@/components/ui/form";
import { useFormContext } from "react-hook-form";
import { CityInput } from "@/components/forms/CityInput";
import { MapPin } from "lucide-react";

export const Step3Location = () => {
  const form = useFormContext();

  return (
    <FormField
      control={form.control}
      name="city"
      render={({ field }) => (
        <FormItem className="space-y-6 w-full">
          <div className="flex flex-col gap-1 mb-2">
            <h1 className="font-h2 text-dark-blue">Où se déroule l&apos;événement ?</h1>
            <p className="font-p text-muted-foreground">
              Entrez la ville où vous souhaitez recevoir le chef.
            </p>
          </div>

          <FormControl>
            <div className="relative bg-white border-2 border-border rounded-2xl px-4 py-3 flex items-center gap-3 focus-within:border-primary transition-colors">
              <MapPin size={20} className="text-primary shrink-0" />
              <CityInput
                inputClassName="border-none p-0 focus:ring-0 bg-transparent w-full font-p"
                value={field.value}
                onChange={(e) => field.onChange(e.target.value)}
              />
            </div>
          </FormControl>
          <FormMessage />

          {/* Suggestions rapides */}
          <div className="space-y-2">
            <p className="text-xs font-semibold text-muted-foreground uppercase tracking-wider">Villes populaires</p>
            <div className="flex flex-wrap gap-2">
              {["Paris", "Lyon", "Marseille", "Bordeaux", "Nice", "Toulouse"].map((city) => (
                <button
                  key={city}
                  type="button"
                  onClick={() => field.onChange(city)}
                  className={`px-3 py-1.5 rounded-full text-sm font-medium border transition-all ${
                    field.value === city
                      ? "bg-primary text-white border-primary"
                      : "bg-white border-border text-dark-blue hover:border-primary/50 hover:bg-primary/5"
                  }`}
                >
                  {city}
                </button>
              ))}
            </div>
          </div>
        </FormItem>
      )}
    />
  );
};
